
<div :class="[classes(n()), props.errorMsg ? classes(n('--error')) : '']">
  <div :class="classes(n('--title'))">
    {{ props.title }}
  </div>
  <div
    :class="[classes(n('--container')), focused ? classes(n('--container--focus')) : '', props.disabled ? classes(n('--container--disabled')) : '']"
  >
    <div
      :class="classes(n('--container--prefix'))"
      @click="handlePrefixClick"
    >
      {{ props.currency }}
    </div>
    <div :class="classes(n('--container--content'))">
      <KeyboardInput
        ref="keyboardInput"
        v-model:value="inputValue"
        :class="classes(n('--keyboard-input'))"
        :value.sync="inputValue"
        :before-input="beforeInput"
        :placeholder="inputPlaceholder"
        :placeholder-position="props.placeholderPosition"
        :disabled="props.disabled"
        :decimal="props.decimal"
        :type="props.type"
        :always-show-keyboard="props.alwaysShowKeyboard"
        :maxlength="props.maxlength"
        :confirm-btn-text="props.confirmBtnText"
        :confirm-btn-enable="props.confirmBtnEnable"
        @focus="handleFocus"
        @input="handleInput"
        @blur="handleBlur"
        @confirm="handleConfirm"
      />
    </div>
  </div>
  <div
    v-if="$slots.footer || props.errorMsg"
    :class="[classes(n('--footer')), props.errorMsg ? classes(n('--footer--error')) : '']"
  >
    <template v-if="props.errorMsg">
      {{ props.errorMsg }}
    </template>
    <template v-else>
      <slot name="footer" />
    </template>
  </div>
</div>
